import React, {useState, useEffect} from 'react';
import { Skeleton } from 'antd';
import LandingPage from './home/LandingPage'
import Login from './home/Login'
import MenuAnt from './MenuAnt'
import CandlestickChart from './CandlestickChart';
export default function LandingLogin() {

    const [selectedMenu, setSelectedMenu] = useState('landingpage');

    const handleLoginSuccess = () => {
        const savedUsername = localStorage.getItem('username');

        if (savedUsername === 'aa') {
            setSelectedMenu('candle'); // Chuyển đến Dashboard
            return;
        }

        setSelectedMenu('menu'); // Chuyển đến Dashboard
        
        
    };

    useEffect(() => {
        const fetchInfo = async () => {
            const token = localStorage.getItem('token'); // Lấy token từ local storage
            const response = await fetch(`${process.env.REACT_APP_API_DB_URL}/info`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`, // Gửi token trong header
                },
            });

            if (response.ok) {
                setSelectedMenu('menu'); // Chuyển đến Dashboard
            } else {
                setSelectedMenu('login'); // Chuyển đến Login
            }
        };

        fetchInfo();
    }, []);

    const renderComponent = () => {
        switch (selectedMenu) {         
            case 'landingpage':
                return <LandingPage />;
            case 'login':
                return <Login onLoginSuccess={handleLoginSuccess} />;
            case 'menu':
                return <MenuAnt chooseMenu={"tragop"} />;
            case 'candle':
                return <CandlestickChart/>
            default:
                return null;
                
        }
    };

    return (
        <>
            {renderComponent()}
        </>
    );
}
